export const DirectoryStatus = {
  active: 'active',
  removed: 'removed',
  suspended: 'suspended',
};
